import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { withNonTrellisComponent, withTrellisComponent } from '../withTrellisCompatibleHoc';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrellisIconDropdownItem = ({
  executeAction,
  toolbarAction
}) => {
  const {
    callback,
    menuLabel,
    menuTooltip,
    disabled,
    id,
    icon: Icon,
    placement = 'right',
    autoPlacement = true
  } = toolbarAction;
  const onClick = () => executeAction({
    id,
    callback
  });
  const button = /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    disabled: !!disabled,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "start",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(Icon, {}), /*#__PURE__*/_jsx(Text, {
        marginInlineStart: "200",
        children: menuLabel
      })]
    })
  }, id);
  if (menuTooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: menuTooltip,
      placement: placement,
      autoPlacement: autoPlacement,
      children: button
    }, id);
  }
  return button;
};
const ToolbarActionsPopover = props => {
  const {
    open,
    placement,
    onOpenChange,
    executeAction,
    Button: CustomButton
  } = props;
  const buttonRef = useRef(null);
  const handleOpenChange = useCallback(evt => {
    if (evt.target.value === true) {
      var _buttonRef$current;
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
    onOpenChange(evt);
  }, [onOpenChange]);
  return /*#__PURE__*/_jsx(UIDropdown, {
    open: open,
    placement: placement,
    onOpenChange: handleOpenChange,
    closeOnOutsideClick: true,
    buttonRef: buttonRef,
    buttonUse: "link-on-dark",
    Button: CustomButton,
    children: /*#__PURE__*/_jsx(UIList, {
      children: props.isTrellisCompatibleComponent ? props.actions.map(toolbarAction => /*#__PURE__*/_jsx(TrellisIconDropdownItem, {
        executeAction: executeAction,
        toolbarAction: toolbarAction
      }, toolbarAction.id)) : props.actions.map(({
        callback,
        menuLabel,
        menuTooltip,
        disabled,
        id,
        icon,
        iconClassName
      }) => {
        const onClick = () => executeAction({
          id,
          callback
        });
        const button = /*#__PURE__*/_jsxs(UIButton, {
          onClick: onClick,
          disabled: !!disabled,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: icon,
            className: iconClassName
          }), menuLabel]
        }, id);
        if (menuTooltip) {
          return /*#__PURE__*/_jsx(UITooltip, {
            title: menuTooltip,
            placement: "right",
            autoPlacement: "horiz",
            children: button
          }, id);
        }
        return button;
      })
    })
  });
};
ToolbarActionsPopover.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  executeAction: PropTypes.func.isRequired,
  placement: PropTypes.string.isRequired,
  actions: PropTypes.array.isRequired,
  Button: PropTypes.func.isRequired
};
export const LegacyToolbarActionsPopover = withNonTrellisComponent(
// @ts-expect-error prop types don't play well with withTrellisHocs
ToolbarActionsPopover);
export const TrellisToolbarActionsPopover = withTrellisComponent(
// @ts-expect-error prop types don't play well with withTrellisHocs
ToolbarActionsPopover);
export default LegacyToolbarActionsPopover;